import { IState } from 'appRedux/createStore';

import { IAction } from '.';

import { casinoReducer } from './casinoReducer';
import { slotHistoryReducer } from './slotHistoryReducer';
import { favoritesReducer } from './favoriteReducer';
import { playlistReducer } from './playlistReducer';
import { filtersReducer } from './filtersReducer';
import { floormapReducer } from './floormapReducer';
import slotReducer from './slotReducer';
import slotCompareReducer from './slotCompareReducer';

export interface IReducer {
  (draft: IState, action: IAction): void;
}

const reducerArray: Array<IReducer> = [
  casinoReducer,
  slotHistoryReducer,
  slotCompareReducer,
  favoritesReducer,
  playlistReducer,
  filtersReducer,
  floormapReducer,
  slotReducer
];

export default reducerArray;
